export enum EVIDENCE_TABS {
  EVIDENCE = 'Evidence',
  EXCLUDED = 'Excluded',
  SOURCE = 'Source',
  PROPERTIES = 'Properties',
  CONTROLS = 'Linked Controls',
  SUGGESTED_CONTROLS = 'Suggested Controls',
  REQUESTS = 'Requests',
}
